import React from 'react';

type Props = {
  color?: string;
  width?: number | string;
  height?: number | string;
};

export const BackToHome: React.FC<Props> = ({ color = '#111', width = 28, height = 28 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 512 512'
      fill='none'
    >
      <g>
        <path
          fill={color}
          d='M443.574 68.426C411.379 36.23 368.736 18.5 323.502 18.5H188.498c-45.234 0-87.876 17.73-120.072 49.926S18.5 143.264 18.5 188.498v135.005c0 45.233 17.731 87.876 49.926 120.071S143.264 493.5 188.498 493.5h135.004c45.234 0 87.876-17.73 120.072-49.926S493.5 368.736 493.5 323.503V188.498c0-45.234-17.731-87.877-49.926-120.072zM468.5 323.503c0 79.952-65.046 144.997-144.998 144.997H188.498C108.546 468.5 43.5 403.455 43.5 323.503V188.498C43.5 108.546 108.546 43.5 188.498 43.5h135.004c79.952 0 144.998 65.046 144.998 144.998zM321.849 175.904 218.234 256l103.615 80.096c5.462 4.222 6.467 12.072 2.245 17.534a12.48 12.48 0 0 1-9.898 4.856c-2.67 0-5.36-.852-7.636-2.611L190.151 265.89a12.502 12.502 0 0 1 0-19.78l116.408-89.985c5.462-4.221 13.313-3.218 17.535 2.245 4.222 5.462 3.217 13.313-2.245 17.534z'
        />
      </g>
    </svg>
  );
};
